import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ingredient-set',
  templateUrl: './ingredient-set.component.html',
  styleUrls: ['./ingredient-set.component.scss']
})
export class IngredientSetComponent implements OnInit {

  @Input() ingredient: any;
  constructor() { }

  ngOnInit(): void {
  }

}
